import * as React from "react";
import { useCallback } from "react";
import * as Immutable from "immutable";
import SearchBar from "data-lake/preview/storage-types/internal/SearchBar";
import DataLakePreview from "data-lake/preview/DataLakePreview";
import useInitialSearchBarFormValues from "data-lake/preview/storage-types/internal/hooks/useInitialFormValues";
import { WIDGET_DEFAULTS, MAX_LOADED_MESSAGES, INTERNAL_DATA_LAKE_SEARCH_TYPE } from "data-lake/preview/Constants";
import { onInitializingTimerange } from "views/components/TimerangeForForm";
import useUserDateTime from "hooks/useUserDateTime";
import { normalizeFromSearchBarForBackend } from "views/logic/queries/NormalizeTimeRange";
import Query from "views/logic/queries/Query";
import generateId from "logic/generateId";
import StreamFilter from "data-lake/preview/StreamFilter";
import { INTERNAL_DATA_LAKE_QUERY } from "data-lake/preview/storage-types/internal/Constants";
import WidgetConfigurationProvider from "data-lake/preview/storage-types/internal/WidgetConfigurationProvider";
import RetrievalProvider from "data-lake/preview/storage-types/internal/contexts/RetrievalProvider";
import PreviewLayoutProvider from "data-lake/preview/storage-types/internal/contexts/PreviewLayoutProvider";
const validate = (formValues) => {
  const errors = {};
  if (!formValues.stream) {
    return { ...errors, stream: "Stream is required" };
  }
  return errors;
};
const InternalDataLakeSearchBar = ({
  executedSearch,
  onReset,
  onSubmit,
  formRef = void 0,
  searchJobIsRunning,
  initialUrlParams
}) => {
  const initialFormValues = useInitialSearchBarFormValues(executedSearch, initialUrlParams);
  return /* @__PURE__ */ React.createElement(
    SearchBar,
    {
      validate,
      rightColumn: /* @__PURE__ */ React.createElement(StreamFilter, null),
      emptyFormValues: {
        timerange: WIDGET_DEFAULTS.timerange,
        stream: void 0,
        fields: void 0
      },
      initialValues: initialFormValues,
      onReset,
      onSubmit,
      formRef,
      searchJobIsRunning
    }
  );
};
const InternalDataLakePreview = ({ initialSearch, initialSearchJob, initialUrlParams, resetUrlQueryParams }) => {
  const { formatTime, userTimezone } = useUserDateTime();
  const renderSearchBar = useCallback(
    ({
      executedSearch,
      onReset,
      onSubmit,
      searchJobIsRunning,
      formRef
    }) => /* @__PURE__ */ React.createElement(
      InternalDataLakeSearchBar,
      {
        formRef,
        executedSearch,
        onReset,
        onSubmit,
        searchJobIsRunning,
        initialUrlParams
      }
    ),
    [initialUrlParams]
  );
  const widgetFromFormValues = useCallback(
    (widget, { fields, timerange, stream }) => {
      var _a;
      const updatedWidgetConfig = widget.config.toBuilder().fieldFilters((fields == null ? void 0 : fields.fieldFilters) ? Immutable.List(fields.fieldFilters) : widget.config.fieldFilters).filtersOperator((_a = fields == null ? void 0 : fields.operator) != null ? _a : widget.config.filtersOperator).build();
      return widget.toBuilder().config(updatedWidgetConfig).timerange(timerange ? normalizeFromSearchBarForBackend(timerange, userTimezone) : widget.timerange).streams([stream]).build();
    },
    [userTimezone]
  );
  const filtersFromSearchType = useCallback(
    (searchType) => {
      var _a, _b;
      return {
        stream: searchType.streams[0],
        timerange: onInitializingTimerange(searchType.timerange, formatTime),
        fields: {
          fieldFilters: (_a = searchType.field_filters) != null ? _a : WIDGET_DEFAULTS.fieldFilters,
          operator: (_b = searchType.filters_operator) != null ? _b : WIDGET_DEFAULTS.fieldsOperator
        }
      };
    },
    [formatTime]
  );
  const queryFromFormValues = useCallback(
    (widget, { stream }) => Query.builder().id(generateId()).query(INTERNAL_DATA_LAKE_QUERY).searchTypes([
      {
        size: MAX_LOADED_MESSAGES,
        filters_operator: widget.config.filtersOperator,
        timerange: widget.timerange,
        streams: [stream],
        field_filters: widget.config.fieldFilters.toArray(),
        fields: widget.config.fields.toArray(),
        type: INTERNAL_DATA_LAKE_SEARCH_TYPE,
        filters: []
      }
    ]).build(),
    []
  );
  return /* @__PURE__ */ React.createElement(WidgetConfigurationProvider, { initialSearch }, /* @__PURE__ */ React.createElement(RetrievalProvider, null, /* @__PURE__ */ React.createElement(PreviewLayoutProvider, null, /* @__PURE__ */ React.createElement(
    DataLakePreview,
    {
      filtersFromSearchType,
      initialSearch,
      initialSearchJob,
      queryFromFormValues,
      resetUrlQueryParams,
      searchBar: renderSearchBar,
      widgetFromFormValues
    }
  ))));
};
export default InternalDataLakePreview;
